import {
  Show,
  SimpleShowLayout,
  TextField,
  DateField
} from 'react-admin';

const CustomerPassportPhysicalShow = () => (
  <Show
    title="Entrega de Passaporte Físico">
    <SimpleShowLayout>
      <TextField source="id" />
      <TextField source="customer_passport" label="Número Passaporte" />
      <TextField source="customer_name" label="Nome" />
      <TextField source="collection_point_passport_name" label="Retirado Em" />
      <TextField source="collection_point_passport_admin_name" label="Entregue Por" />
      <DateField source="date_withdrawal" locales="pt-BR" label="Data Retirada" showTime />
      <DateField source="created_at" locales="pt-BR" label="Criado Em" showTime />
    </SimpleShowLayout>
  </Show>
);

export default CustomerPassportPhysicalShow;
